import JILIFISHActions from './JILIFISHActions'

export default class TADAFISHActions extends JILIFISHActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'FH',
      gameName: 'Ocean King Jackpot',
      gameCode: 'TADA-FISH-001',
      platform: 'TADA',
    }
  }
}
